// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"yX","selections":"zX","pillsDesktopSearchMenu":"AX"};